/** 서버에 /login 문서를 요청하지 않고 앱 내부의 로그인 화면으로 이동한다. */
export async function navigateToLogin(reason: 'logout' | 'expired') {
  // router가 인증/API 모듈을 참조하므로 실행 시점에 불러와 순환 초기화를 피한다.
  const { router } = await import('@/app/router')
  await router.navigate(`/login?reason=${reason}`, { replace: true })
}
